// Match Operation Center 赛事运维中心
export default {
  name: '赛事运维中心',
  path: '/operation',
  redirect: '/operation/simtrade',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      name: '模拟交易信息查询',
      path: '/operation/simtrade',
      redirect: '/operation/simtrade/accountInfo',
      children: [
        {
          name: '账户信息',
          path: '/operation/simtrade/accountInfo',
          component: () => import('@/views/operation/simtrade/accountInfo/index.vue'),
        },
        {
          name: '日收益率信息',
          path: '/operation/simtrade/dailyYieldList',
          component: () => import('@/views/operation/simtrade/dailyYieldList/index.vue'),
        },
        {
          name: '资金信息',
          path: '/operation/simtrade/fundAssetList',
          component: () => import('@/views/operation/simtrade/fundAssetList/index.vue'),
        },
        {
          name: '持仓信息',
          path: '/operation/simtrade/stkAssetList',
          component: () => import('@/views/operation/simtrade/stkAssetList/index.vue'),
        },
        {
          name: '委托信息',
          path: '/operation/simtrade/orderReportList',
          component: () => import('@/views/operation/simtrade/orderReportList/index.vue'),
        },
        {
          name: '成交信息',
          path: '/operation/simtrade/matchReportList',
          component: () => import('@/views/operation/simtrade/matchReportList/index.vue'),
        },
      ],
    },
    {
      name: 'Redis管理',
      path: '/operation/redisManage',
      redirect: '/operation/redisManage/redisQuery',
      children: [
        {
          name: 'Redis查询',
          path: '/operation/redisManage/redisQuery',
          component: () => import('@/views/operation/redisManage/redisQuery/index.vue'),
        },
        {
          name: 'Redis批处理',
          path: '/operation/redisManage/redisBatchHandle',
          component: () => import('@/views/operation/redisManage/redisBatchHandle/index.vue'),
        },
      ],
    },
    {
      name: '数据库管理',
      path: '/operation/dbManage',
      redirect: '/operation/dbManage/dbQuery',
      children: [
        {
          name: '数据库查询',
          path: '/operation/dbManage/dbQuery',
          component: () => import('@/views/operation/dbManage/dbQuery/index.vue'),
        },
        {
          name: '数据库批处理',
          path: '/operation/dbManage/dbBatchHandle',
          component: () => import('@/views/operation/dbManage/dbBatchHandle/index.vue'),
        },
      ],
    },
    {
      name: '接口管理',
      path: '/operation/interfaceManage',
      redirect: '/operation/interfaceManage/interfaceGroupConfig',
      children: [
        {
          name: '接口分组',
          path: '/operation/interfaceManage/interfaceGroupConfig',
          component: () => import('@/views/operation/interfaceManage/interfaceGroupConfig/index.vue'),
        },
        {
          name: '接口模板配置',
          path: '/operation/interfaceManage/interfaceTemplateConfig',
          component: () => import('@/views/operation/interfaceManage/interfaceTemplateConfig/index.vue'),
        },
        {
          name: '接口操作',
          path: '/operation/interfaceManage/interfaceOperate',
          component: () => import('@/views/operation/interfaceManage/interfaceOperate/index.vue'),
        },
      ],
    },
    {
      name: '配置管理',
      path: '/operation/configManage',
      redirect: '/operation/configManage/dictConfig',
      children: [
        {
          name: '字典配置',
          path: '/operation/configManage/dictConfig',
          component: () => import('@/views/operation/configManage/dictConfig/index.vue'),
        },
        {
          name: '赛事奖励配置',
          path: '/operation/configManage/matchRewardConfig',
          component: () => import('@/views/operation/configManage/matchRewardConfig/index.vue'),
        },
        {
          name: '赛项奖励配置',
          path: '/operation/configManage/eventRewardConfig',
          component: () => import('@/views/operation/configManage/eventRewardConfig/index.vue'),
        },
        {
          name: '邀新奖励配置',
          path: '/operation/configManage/inviteRewardConfig',
          component: () => import('@/views/operation/configManage/inviteRewardConfig/index.vue'),
        },
      ],
    },
  ],
};
